export default "__VITE_ASSET__0SjHNvbE__"